module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_8011.ca2b5106.png";